<template>
  <div :class="`present theme-${currentBox ? (currentBox.theme || 'default') : 'default'}`">
    <article ref="main" id="present-main" class="present__main" v-if="currentBox">
      <div class="componata-container">
        <div class="grid">
          <div class="col-7_md-12">

            <p class="present__go-back-wrapper"><router-link :to="cLink('/fertige')" class="present__go-back"><i class="icon icon-angle-left"></i> Zurück zur Übersicht</router-link></p>

            <h4 class="present__title">{{ currentBox.name }} <small v-if="$store.getters.isB2b">SKU: {{ currentBox.id }}</small></h4>
            <span class="present__tags">
            <ul class="present__ul">
              <li v-for="tag in currentBox.level1_tags" :key="tag.level1_feature_title">
                <Popper placement="top">
                <span class="u-text-muted present__feature"><a :style="{'color':tag.level1_feature_color}"><i class="present__icon" v-html="addClassToIcon(tag.level1_feature_icon, tag.level1_feature_color)"></i>  {{ tag.level1_feature_title }}</a></span>
                    <template v-slot:popover>
                      <slot>
                        {{ tag.level1_feature_description }}
                      </slot>
                      </template>
                    </Popper>
              </li>
            </ul>
          </span>
            <span class="present__description">{{ cleanDescString(currentBox.description) }}</span>

            <Gallery
              ref="gallery"
              v-if="currentBox.gallery"
              :data="currentBox"
              :key="$store.getters.isB2b"
              @click="galleryClick"
            />
          </div>

          <div class="col-5_md-12">
            <a-b name="composer-starting-tab">
              <template slot="A" chance="1">
                <Composer
                  ref="composer"
                  defaultModuleId="present"
                  environment="present"
                  :defaults="false"
                  @click="composerClick"
                  class="present__composer"
                />
              </template>

              <template slot="B" chance="1">
                <Composer
                  ref="composer"
                  defaultModuleId="postcard"
                  environment="present"
                  :defaults="false"
                  @click="composerClick"
                  class="present__composer"
                />
              </template>
            </a-b>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';
import { UiMixin } from '@/mixins/UiMixin';
import Popper from '@/components/Popper';
import Gallery from '@/components/PresentPage/Gallery';
import Composer from '@/components/Composer/Composer';

export default {
  name: 'Present',
  components: {
    Gallery,
    Composer,
    Popper
  },
  mixins: [logicMixin, UiMixin],
  props: ['boxId', 'postcards'],
  methods: {
    composerClick () {
      if (this.$store.getters.getMediaQueries.max.md.matches) {
        this.scrollTo('composer', null, null, -15);
        this.$refs.gallery.stop(1);
      }

      if (this.$store.getters.getMediaQueries.min.md.matches) {
        this.scrollTo('present-main');
        this.$refs.gallery.stop(1);
      }
    },

    galleryClick () {
      this.scrollTo('present-main');
    },

    cleanDescString(descWithTags) {
      return descWithTags.replace(/(<([^>]+)>)/ig, '');
    },

    addClassToIcon(icon, color) {
      return icon.replace('<svg', '<svg class="present__icon"').replace(/height="[0-9]{2,}"/ig, '').replace(/width="[0-9]{2,}"/ig, '').replace('></path>', 'style=fill:' + color + '></path>');
    }
  },
  computed: {
    currentBox() {
      return this.$store.getters.getSelectedItem.data;
    },
  },
  mounted () {
    if (window.location.hash && window.location.hash === '#edit') {
      this.scrollTo('composer', null, null, -15);
    } else {
      // Set scroll directly to the present area so the Composer is fully visible on the viewport if the height is smaller than the anmount indicated below
      if (window.innerHeight < 900) {
        this.scrollTo('present-main');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Present
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Present - product's hero
 * @since 2021-04-09
**/

$component: 'present';

.#{$component} {
  // …

  &__main {
    [class^='grid']:first-of-type {
      @include padding-top(map-get($spacers, 4));
    }
  }

  &__presentation {
    z-index: 0;
    @include margin-top(- map-get($spacers, 6) * 3);
  }

  &__photo-wrap {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 86%;
    height: auto;
    margin: 0 auto;
    aspect-ratio: 1 / 1;
  }

  &__photo-stretcher {
    width: 100%;
    height: auto;
  }

  &__photo {
    position: absolute;
    width: 100%;
    aspect-ratio: 1 / 1;
    cursor: pointer;

    &.--is-size-s {
      width: 78%;
    }
  }

  &__postcard {
    width: calc(100vh / 3);
    @include rfs(20rem, max-width);
    margin-top: -17%;
  }

  &__go-back-wrapper {
    z-index: 1;
    margin: 0;
  }

  &__go-back {
    display: inline-block;
    position: relative;
    color: white;
    text-shadow: 1px 1px 6px rgba($ink, 0.4);

    .icon {
      position: absolute;
      @include rfs(- ($font-size-base * 2), left);
      @include rfs(- 0.3rem, top);
      @include font-size($font-size-base * 2);
      vertical-align: middle;
      transition: transform 0.2s ease-in-out;
    }

    @include hover () {
      .icon {
        transform: translateX(- map-get($spacers, 1));
      }
    }
  }

  &__description {
    color: white;
  }

  &__icon {
    height: 1rem;
    width: 1rem;
    display: inline-block;
  }

  &__ul {
    list-style: none;
    padding-left: 0rem;
    margin: 0rem 0rem 0rem 0rem;
  }

  &__ul li {
    display: inline;
    margin-right: 1rem;
  }

  &__ul li:not(:last-child)::after {
  content: " ";
  }

  &__title {
    // @include margin(0 0 map-get($spacers, 3));
    margin: 0rem 0rem 0rem 0.1rem;
    @include font-size(map-get($landing-page, 'font-size-xl'));
    color: white;
    text-shadow: 1px 1px 6px rgba($ink, 0.4);

    small {
      display: block;
      @include font-size(map-get($landing-page, 'font-size-base') / 1.4);
      font-weight: $font-weight-light;
      opacity: 0.6;
    }
  }

  &__composer {
    z-index: 1;
    @include margin-bottom(- (map-get($spacers, 3) * 5));
  }

  &__footer {
    @include padding-top(map-get($spacers, 5));
    @include padding-bottom(map-get($spacers, 4));
    background: rgba($ink, 0.1);
  }

  &__usp {
    display: flex;
    align-items: flex-start;
    color: $white;
  }

  &__usp-icon {
    position: relative;
    @include rfs(2.6rem, flex-basis);
    flex-grow: 0;
    flex-shrink: 0;
    @include margin-right(map-get($spacers, 3));

    &:after {
      content: '\e913';
      position: absolute;
      @include rfs(-0.7rem, right);
      bottom: 0;
      background-color: $white;
      border-radius: 50%;
      color: $primary;
      font-family: 'icomoon';
      line-height: 1;
    }
  }

  &__usp-text {
    flex-grow: 1;
    line-height: $line-height-base-sm;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
    &__presentation {
      @include margin-top(- map-get($spacers, 6));
      @include margin-bottom(- map-get($spacers, 4) * 3); // Substract the negative space of the photo itself that doesn't work really well in vertical layout (mobile)
      @include padding-right(map-get($spacers, 4) * 2);
      @include padding-left(map-get($spacers, 4) * 2);
    }

    &__go-back {
      padding: 0;
      // border-radius: 50px;
      color: $white;
      text-shadow: none;
      // background: $white;

      .icon {
        // position: static;
        @include rfs(0, top);
      }
    }

    &__title {
      @include margin-bottom(map-get($spacers, 3));
    }

    &__postcard {
      @include margin-top(- map-get($spacers, 6) * 3);
      @include margin-bottom(map-get($spacers, 4) * 4);
    }

    &__footer {
      @include margin-top(map-get($spacers, 6) * 2);
      background: transparent !important;
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    &__presentation {
      @include margin-top(- map-get($spacers, 6));
    }

    &__footer {
      @include margin-top(map-get($spacers, 6) * 2);
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    &__presentation {
      padding-right: unset;
      padding-left: unset;
    }

    &__usp-icon {
      @include margin-right(map-get($spacers, 5));
    }
  }
}
</style>
